import { gql } from '@apollo/client';

export const GET_METRIC_GRAPH = gql`
  query GetMetricGraph(
    $patient: ID!
    $metricDefinitionId: ID!
    $filter: GqlMetricGraphFilter!
  ) {
    metric {
      metric {
        patientMetricGraph(
          patient: $patient
          metricDefinitionId: $metricDefinitionId
          filter: $filter
        ) {
          items {
            title
            metricDefinitionId
            metricDefinition {
              id
              title
              translations
            }
            unit
            graphData {
              date
              score
              questionnaireResponseId
              value {
                value
                code
              }
            }
          }
        }
      }
    }
  }
`;
